import { ChangeDetectionStrategy, Component, DestroyRef, effect, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import {
    EntitiesSelectionFilter,
    ZoneDelimiterFilter,
} from '@connect-services/client/components/statistics/statistics.component';
import { GeographicFilterService } from '@connect-services/client/services/geographic-filter.service';
import {
    MapModalSelectionModeEnum,
    SelectionService,
} from '@connect-services/client/services/map/selection/selection.service';
import { MapModal, MapModalService } from '@connect-services/client/services/map-modal.service';
import {
    STATISTICS_FILTER_LOCAL_STORAGE_KEY,
    StatisticService,
} from '@connect-services/client/services/statistic.service';
import {
    ButtonComponent,
    ButtonType,
    IconPosition,
} from '@connect-services/src/lib/components/button/button.component';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, RessourcesModule],
    selector: 'app-statistic-geographic-filter-actions',
    styleUrl: './statistic-geographic-filter-actions.component.scss',
    templateUrl: './statistic-geographic-filter-actions.component.html',
})
export class StatisticGeographicFilterActionsComponent implements OnInit {
    protected readonly ButtonType = ButtonType;
    protected readonly geographicFilterService = inject(GeographicFilterService);
    protected readonly IconPosition = IconPosition;
    protected readonly selectionService = inject(SelectionService);
    protected readonly statisticService = inject(StatisticService);

    private readonly activatedRoute = inject(ActivatedRoute);
    private readonly destroyRef = inject(DestroyRef);
    private readonly mapModalService = inject(MapModalService);

    public constructor() {
        effect(() => {
            this.destroyRef.onDestroy(async () => {
                await this.closeGeographicFilter();
            });
        });
    }

    public ngOnInit(): void {
        this.activatedRoute.queryParams.subscribe((queryParams: Params) => {
            if (queryParams['geographicFilter'] && localStorage.getItem(STATISTICS_FILTER_LOCAL_STORAGE_KEY)) {
                const filter: EntitiesSelectionFilter | ZoneDelimiterFilter = JSON.parse(
                    localStorage.getItem(STATISTICS_FILTER_LOCAL_STORAGE_KEY)!,
                );
                if (filter.type === 'zoneDelimiter') {
                    this.statisticService.wktStringMultipolygon.set(filter.filter);
                }
                if (filter.type === 'entitiesSelection') {
                    this.statisticService.selectedLayersAndEntities.set(filter.filter);
                }
            }
        });
    }

    protected async closeGeographicFilter(): Promise<void> {
        await this.selectionService.clearAllSelections(true);
        this.mapModalService.close(MapModal.FILTER);
    }

    protected async toggleGeographicFilter(): Promise<void> {
        if (!this.selectionService.isFilterModalOpen()) {
            this.openGeographicFilter();

            this.selectionService.isFilterModalOpen.set(true);

            return;
        }
        await this.closeGeographicFilter();
    }

    private openGeographicFilter(): void {
        this.selectionService.setModalMode(MapModalSelectionModeEnum.STATISTICS);
        this.mapModalService.open(MapModal.FILTER);
    }
}
